import Vue from 'vue';
import "./fonts/iconfont.css"

    import { slice } from "../../../src/filters"

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    
import {
  Menu,
  MenuItem,
  Carousel,
  CarouselItem,
  Button,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Submenu,
  Drawer,
  MessageBox
} from "element-ui"

export default {
  components: {
    [Menu.name]: Menu,
    [MenuItem.name]: MenuItem,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [Submenu.name]: Submenu,
    [Button.name]: Button,
    [Drawer.name]: Drawer,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem,
    [DropdownItem.name]: DropdownItem
  },
  // ref: https://github.com/kopiro/siriwave#constructor-options
  props: {
    logo: {
      default: ""
    },
    defaultActived: {
      default: ""
    },
    menus: {
      default: []
    },
    user: {
      default: {}
    },
    IMBaseUrl: {
      default: ""
    },
    ENV: {
      default: "dev"
    },
    logoutUrl: {
      default: ""
    },
    appName: {
      default: "xreports"
    },
    badgeCount: {
      default: null
    },
    params: {
      default: () => {
        return { theme: "white" }
      }
    },
    hotelname: {
      default: ""
    },
    pcPageBlack: {
      default: () => []
    },
    limitNewMenu: {
      default: true
    }
  },
  filters: {
    slice
  },
  data() {
    return {
      newMenu: [],
      shortMenus: [],
      showMoreMenu: false, //是否展示折叠的更多菜单
      initMore: false,
      defaultActivedMenu: "/hotelcem/home",
      drawer: false,
      currentMenu: {},
      brandStyles: {},
      currentRoute: {},
      iconCount: 0,
      device: "pc",
      IM_BASEURL: {
        dev: "https://im-fat.vocustcloud.com?generateKey=BemQMQYlfES2auforI9qlMtVQ3RXkT/zc1J2EU6zYh/VdbKXPTQurQ==",
        fat: "https://im-fat.vocustcloud.com?generateKey=BemQMQYlfES2auforI9qlMtVQ3RXkT/zc1J2EU6zYh/VdbKXPTQurQ==",
        fort: "https://cdn.vocustcloud.com/im-client/index.html?generateKey=BemQMQYlfET9L+/soCEv+CE7HZcITB2ALUKR8a2v6HojJciUmLZPNg==",
        prod: "https://cdn.vocustcloud.com/im-client/index.html?generateKey=BemQMQYlfET9L+/soCEv+CE7HZcITB2ALUKR8a2v6HojJciUmLZPNg==",
        uat: "https://cdn.vocustcloud.com/im-client/index.html?generateKey=BemQMQYlfET9L+/soCEv+CE7HZcITB2ALUKR8a2v6HojJciUmLZPNg=="
      },
      REDIRECT_CASURL: {
        dev: "https://login-fat.vocust.com",
        fat: "https://login-fat.vocust.com",
        fort: "https://login.vocust.com",
        prod: "https://login.vocust.com",
        uat: "https://login-uat.vocust.com"
      },
      curSelectedParentPath: "",
      menuIntroductions: {},
      menuBanners: {},
      brandLogo: "",
      brandLogoWhite: "",
      matchedCustomerLogo: false,
      specialTenantLogo: {
        315430: ""
      },
      oldValueSnapshot: null,
      langText: {
        en: {
          changeMode: "Use the new Nav"
        },
        "zh-cn": {
          changeMode: $t("5556ba0c8eacf558")
        }
      }
    }
  },
  watch: {
    "user.tenantId": {
      handler(newVal) {
        // if (["479640"].includes(newVal)) {
        //   this.brandStyles = { height: "auto", width: "110px" }
        // }
        if (["315430", "334886"].includes(newVal)) {
          // return require("./images/brand_shangmei_logo.png")
          import("./images/brand_shangmei_logo.png").then(({ default: img }) => {
            this.brandLogo = img
            this.matchedCustomerLogo = true
          })
        } else if (["866529", "940263"].includes(newVal)) {
          // 唯品会
          // return require("./images/brand_weipinhui_logo.png")
          import("./images/brand_weipinhui_logo.png").then(({ default: img }) => {
            this.brandLogo = img
            this.matchedCustomerLogo = true
          })
        } else if (["479640"].includes(newVal)) {
          // CITC
          // return require("./images/brand_citc_logo.png")
          import("./images/brand_citc_logo.png").then(({ default: img }) => {
            this.brandLogo = img
            this.matchedCustomerLogo = true
          })
        } else {
          this.brandLogo = require("./images/voc_brand_logo.png")
          this.brandLogoWhite = require("./images/voc_brand_logo_white.png")
        }
      },
      immediate: true
    },
    $route: {
      handler() {
        this.defaultActivedMenu = this.$route.name
        this.currentMenu = {}
        this.findCurrentMenu(this.menus)
      },
      deep: true,
      immediate: true
    },
    menus: {
      async handler(newVal) {
        if (!this.isSame(newVal, this.oldValueSnapshot)) {
          this.initMenu(newVal)
        }
        if (newVal) {
          this.oldValueSnapshot = JSON.parse(JSON.stringify(newVal))
        }
      },
      deep: true,
      immediate: true
    },
    limitNewMenu: {
      handler() {
        this.$nextTick(() => {
          console.log("limitNewMenu", this.limitNewMenu)
          this.distributionMenu()
        })
      },
      immediate: true
    }
  },

  created() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.device = "mobile"
    }
    this.initMenu(this.menus)
  },

  mounted() {
    this.distributionMenu()
    this.resizeWindow()
  },
  methods: {
    isSame(val1, val2) {
      let flag = true
      if (val1 === null || val2 === null) {
        return val1 === val2
      }
      if (typeof val1 === "object" && typeof val2 === "object") {
        const keys1 = Object.keys(val1)
        const keys2 = Object.keys(val2)
        if (keys1.length !== keys2.length) {
          return false
        }
        for (let i = 0; i < keys1.length; i++) {
          const isequal = this.isSame(val1[keys1[i]], val2[keys1[i]])
          if (!isequal) {
            flag = false
            break
          }
        }
        return flag
      }
      return val1 === val2
    },

    changeMode() {
      MessageBox.confirm($t("022a3d7c171bb839"), $t("daaaeb1b7b22b126"), {
        confirmButtonText: $t("204ffab8a6e01870"),
        cancelButtonText: $t("4b3340f7872b411f"),
        type: "warning"
      })
        .then(() => {
          this.$emit("changeMode", 2)
        })
        .catch(() => {})
    },
    initMenu(menuData) {
      let menus = JSON.parse(JSON.stringify(menuData))
      this.newMenu = menus.map(item => {
        item.showThisMenu = true
        if (item.children) {
          item.children.map(it => {
            it.defaultSource = it.source?.split(";")[0] || ""
            it.sourceImg = it.source?.split(";")[1] || ""
            return it
          })
        }
        item.childrenAsync = []
        item.showIcon = false
        return item
      })
      this.syntheticMenuIntroductions()
      this.distributionMenu()
      console.log(this.newMenu, menus)
    },
    resizeWindow() {
      let resizeTimer = true
      let that = this
      window.onresize = function () {
        if (resizeTimer) {
          resizeTimer = false
          setTimeout(function () {
            resizeTimer = true
            that.distributionMenu()
          }, 500)
        }
      }
    },

    distributionMenu() {
      let that = this
      that.shortMenus = []

      // todo
      if (!document.querySelector(".voc-header-left")) {
        return
      }
      let cw = document.querySelector(".voc-header-left").clientWidth - 140 //- (that.appName === "cem_vp" ? 450 : 520)

      // eslint-disable-next-line no-unused-vars
      let index = 0
      let margin = 40

      if (cw < 610) {
        // 只能显示核心菜单
        index = 4
      }
      // eslint-disable-next-line no-unused-vars

      if (cw > 610) {
        index = this.getIndex(index, cw, margin)
      }

      for (let i = 0; i < that.newMenu.length; i++) {
        if (i < index) {
          that.newMenu[i].showThisMenu = true
        } else {
          that.newMenu[i].showThisMenu = false
          // 如果that.newMenu[i]是不包含children的，要把他弄成这种格式
          that.shortMenus.push(that.newMenu[i])
        }
      }
      that.showMoreMenu = that.shortMenus.length > 0
    },

    getIndex(index, cw, margin) {
      let that = this
      let oneSize = this.$lang === "en" ? 8.7 : 16
      for (let i = 0; i < that.newMenu.length; i++) {
        //alias
        let arrowWidth = 0
        if (that.params.theme !== "dark" && that.newMenu[i].children && that.newMenu[i].children.length > 0) {
          arrowWidth = 20
        }
        cw =
          cw -
          (this.$lang === "en" ? that.newMenu[i].alias?.length || 0 : that.newMenu[i].name.length) * oneSize -
          margin -
          arrowWidth
        if (cw < 95) {
          index = i //
          return index
        }
      }
      return cw > 95 ? that.newMenu.length : index
    },

    syntheticMenuIntroductions() {
      for (let i = 0; i < this.newMenu.length; i++) {
        this.menuIntroductions[this.newMenu[i].code] = {
          title: this.newMenu[i].name || "", // 一级标题
          desc: this.newMenu[i].remark || "", // 一级描述
          style: { width: "399px" },
          source: this.newMenu[i].source || "",
          alias: this.newMenu[i].alias
        }
      }
    },
    getImgPath(source, index) {
      return source.split(";")[index] || ""
    },

    onChangeLanguage(language) {
      const originalLanguage = this.$root._$lang || this.$root.$root.lang
      localStorage.setItem("VOC-LANGUAGE", language)
      if (originalLanguage !== language) location.reload()
      // location.reload()
    },
    getRouteName(route) {
      const lang = this.$lang
      if (lang === "en" && route.alias) return route.alias
      else return route.name
    },

    drawerOpen() {
      if (this.$refs.carousel) this.$refs.carousel.setActiveItem(0)
      if (this.currentRoute.path) this.$refs.carouselMenu.close(this.currentRoute.path)
    },
    carouselBack() {
      this.$refs.carouselMenu.close(this.currentRoute.path)
      this.$refs.carousel.prev()
    },
    findCurrentMenu(menus = [], parentMenu = {}) {
      const that = this
      const { $route } = this
      menus.forEach(item => {
        if (
          item.code === $route.name ||
          item.path === $route.path
          // ($route.name && $route.name.indexOf(item.code) !== -1)
        ) {
          that.currentMenu = Object.assign({}, item)
          that.currentMenu.parentMenu = parentMenu
          that.currentMenu.parentName = parentMenu.code
        }
        if (item.children && item.children.length > 0) this.findCurrentMenu(item.children, item)
      })
    },

    onDrawerMenuSelect(path) {
      let route = null
      this.newMenu.some(item => {
        if (item.path === path) {
          route = item
          return true
        }
      })
      this.currentRoute = route
      this.$refs.carousel.next()
    },
    onMenuSelect(item) {
      const { path } = item
      this.curSelectedParentPath = path
      this.drawer = false
      this.$emit("menuClick", item)
      this.$forceUpdate()
    },
    navClick(item, parent) {
      this.curSelectedParentPath = parent.path
      this.$forceUpdate()
      this.$emit("menuClick", item)
      this.drawer = false
    },
    onSelectApplication() {
      this.$emit("onSelectApplicationClick")
      const language = localStorage.getItem("VOC-LANGUAGE")
      window.open(`${this.REDIRECT_CASURL[this.ENV]}${language === "en" ? "/en-US" : ""}/#/system-select`, "_self")
    },
    onCallIM() {
      const { user, hotelname } = this
      let nickname = hotelname ? `${hotelname}+${user.userName}` : user.userName
      window.open(`${this.IM_BASEURL[this.ENV]}&agentUid=${user.userId}&nickname=${nickname}`)
    },
    onClickCallOut() {
      if (this.ENV !== "prod") {
        window.open(`https://oc-fat.vocust.com/`)
      } else {
        window.open(`https://oc.vocust.com`)
      }
    },
    onLogout() {
      MessageBox.confirm($t("aa7e6c204c751cfa"), $t("daaaeb1b7b22b126"), {
        confirmButtonText: $t("204ffab8a6e01870"),
        cancelButtonText: $t("4b3340f7872b411f"),
        type: "warning"
      })
        .then(() => {
          if (this.logoutUrl) {
            window.location.href = `${this.logoutUrl}${
              this.logoutUrl.indexOf("?") !== -1 ? "&" : "?"
            }back=${encodeURIComponent(location.href)}`
          } else {
            this.$router.push({
              path: "/system/logout",
              query: {
                back: encodeURIComponent(location.href)
              }
            })
          }
        })
        .catch(() => {})
    },
    goPage(path) {
      window.location.href = `${window.location.origin}/${this.appName}${path}`
    }
  }
}
